import { useEffect, useRef } from 'react'
import { toast } from 'react-toastify'

import { Loader } from '@/components'
import { useAppContext } from '@/hooks'

type Props = {
	nodeId: number
	onDownloadFinish: () => void
}

/** V1 JSON export is gone and there is no V2 replacement. */
export const ExportStructure = ({ nodeId, onDownloadFinish }: Props) => {
	const { t } = useAppContext()
	const notified = useRef(false)

	useEffect(() => {
		if (notified.current) return
		notified.current = true
		toast(t('EXPORT_NOT_AVAILABLE', [String(nodeId)]), { type: 'error' })
		onDownloadFinish()
	}, [nodeId, onDownloadFinish, t])

	return <Loader loaded={false} />
}
